<template>
  <div id="centro-sub-tab">
    <v-layout align-center justify-center>
      <v-flex lg12>
        <template>
          <v-tabs v-model="active_tab">
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <!-- TAB DE CRONOGRAMA -->
              <v-card
                :key="cardCronograma"
                flat
                v-if="tabSelected == 'Cronograma'"
              >
                <cronograma-ca-co
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></cronograma-ca-co>
              </v-card>
              <!-- TAB DE TRASPASO -->
              <v-card :key="cardTraspaso" flat v-if="tabSelected == 'Traspaso'">
                <traspaso-ca-co
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></traspaso-ca-co>
              </v-card>
              <!-- TAB DE CAPACITACION -->
              <!-- <v-card :key="cardCapacitacion" flat v-if="tabSelected=='Capacitacion'">
                <capacitacion-centro-tab :show="true" :tipeView="'modifica'" :contratoId="contratoId"></capacitacion-centro-tab>
              </v-card> -->
            </v-tabs-items>
          </v-tabs>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import CronogramaCaCo from "@/modules/aplicacion/views/traspasoCo/CronogramaCaCo.vue";
import TraspasoCaCo from "@/modules/aplicacion/views/traspasoCo/TraspasoCaCo.vue";

export default {
  name: "centro-sub-tab",

  components: {
    CronogramaCaCo,
    TraspasoCaCo,
  },
  props: {},
  data: () => ({
    text: "En construccion",
    proveedor: {},
    tabs: ["Cronograma", "Traspaso"],
    contratoId: "",
    tabSelected: "",
    activeTab: "",
    index: "",
    active_tab: "",
    cardCronograma: 0,
    cardTraspaso: 10,
    cardCapacitacion: 20,
  }),
  mounted() {},
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proceso = this.$store.getters.proSelectedStored;

    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
    this.loadSelected();
    this.active_tab = this.tabs.indexOf(
      this.$store.getters.subTabSelectedStored
    );
  },
  methods: {
    loadSelected() {
      this.tabSelected = this.$store.getters.subTabSelectedStored;
    },
    selected(tab) {
      this.tabSelected = tab;
      this.$store.commit("sub_tab_state", tab);
      if (this.tabSelected == "Cronograma") {
        this.reloadAcopio();
      }
      if (this.tabSelected == "Traspaso") {
        this.reloadOperacion();
      }
      if (this.tabSelected == "Capacitacion") {
        this.reloadCapacitacion();
      }
    },
    reloadAcopio() {
      this.cardCronograma += 1;
    },

    reloadOperacion() {
      this.cardTraspaso += 11;
    },

    reloadCapacitacion() {
      this.cardCapacitacion += 21;
    },
  },
};
</script>
